@if (focusedLocation() || focusedCountry()) {
    <div class="map-layout-cards" [ngClass]="{ hideMobile: true }">
        <si-card class="map-layout-cards__drawer-card">
            <div body class="map-layout-cards__drawer-body">
                <app-drawer
                    [view]="view()"
                    [focusedLocation]="focusedLocation()"
                    [userDetail]="userDetail()"
                    [focusedCountry]="focusedCountry()"
                    [loading]="isLoading()"
                ></app-drawer>
            </div>
        </si-card>

        <si-card class="map-layout-cards__map-card">
            <div body class="map-container">
                @if (isLoading()) {
                    <div class="loading-container">
                        <app-loading-indicator></app-loading-indicator>
                    </div>
                }
                <div class="map-scroll">
                    <div
                        id="map"
                        leaflet
                        (leafletMapReady)="onMapReady($event)"
                        [leafletOptions]="mapOptions"
                        [leafletMarkerCluster]="markers()"
                        [leafletMarkerClusterOptions]="markerClusterOptions"
                    ></div>
                </div>
            </div>
        </si-card>
    </div>
} @else {
    <si-card class="map-layout-cards__map-card map-layout-cards__map-card--full">
        <div body class="map-container map-container--full">
            @if (isLoading()) {
                <div class="loading-container">
                    <app-loading-indicator></app-loading-indicator>
                </div>
            }
            <div class="map-scroll">
                <div
                    id="map"
                    leaflet
                    (leafletMapReady)="onMapReady($event)"
                    [leafletOptions]="mapOptions"
                    [leafletMarkerCluster]="markers()"
                    [leafletMarkerClusterOptions]="markerClusterOptions"
                ></div>
            </div>
        </div>
    </si-card>
}

@if (focusedLocation() || focusedCountry()) {
    <div class="onlyMobile">
        <app-drawer
            [view]="view()"
            [focusedLocation]="focusedLocation()"
            [focusedCountry]="focusedCountry()"
            [loading]="isLoading()"
            [userDetail]="userDetail()"
        ></app-drawer>
    </div>
}
